import * as React from 'react';

// #region Component Props

interface IProps {
    label: string;
    value: string|number|undefined;
    contentValue?: any;
}

// #endregion

export const DataGroupPoint = (props: IProps) => (
    <React.Fragment>
        <dt>{ props.label }</dt>        
        <dd>
            { 
                props.contentValue ? props.contentValue : props.value 
            } 
            &nbsp;
        </dd>
    </React.Fragment>
);
